import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';

@autoinject
@customElement('edit6')
export class Edit6CustomElement extends BaseCustomElement {
}